export default "__VITE_ASSET__W0pUa_7s__"